import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  Input,
  QueryList,
  ViewChild,
  ViewChildren,
  OnInit,
} from '@angular/core'
import {
  Facet,
  FacetValue,
  CmsService,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core'
import { Observable } from 'rxjs'

import { FacetService } from '../services/facet.service'
import {
  ICON_TYPE,
  FocusDirective,
  FacetCollapseState,
} from '@spartacus/storefront'
import { ActivatedRoute, Router } from '@angular/router'
import { ProductListComponentService } from '../../list/product-list-component.service'
import { PlpService } from '../../plp.service'

@Component({
  standalone: false,

  selector: 'cx-facet',
  templateUrl: './facet.component.html',
  styleUrls: ['./facet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FacetComponent implements OnInit {
  // tslint:disable-next-line: variable-name
  protected _facet: Facet

  state$: Observable<FacetCollapseState>

  /** configurable icon that is used to collapse the facet group  */
  @Input() expandIcon: ICON_TYPE = ICON_TYPE.EXPAND
  @Input() collapseIcon: ICON_TYPE = ICON_TYPE.COLLAPSE

  @HostBinding('class.multi-select') isMultiSelect: boolean

  @ViewChildren('facetValue') values: QueryList<ElementRef<HTMLElement>>

  @ViewChild(FocusDirective) keyboardFocus: FocusDirective
  params: any
  length: number

  @Input()
  set facet(value: Facet) {
    this._facet = value
    this.isMultiSelect = !!value.multiSelect
    this.state$ = this.facetService.getState(value)
  }

  get facet(): Facet {
    return this._facet
  }

  constructor(
    protected facetService: FacetService,
    protected elementRef: ElementRef<HTMLElement>,
    protected cd: ChangeDetectorRef,
    public router: Router,
    public routes: ActivatedRoute,
    public cmsService: CmsService,
    public productListComponentService: ProductListComponentService,
    private globalMessageService: GlobalMessageService,
    private plpService: PlpService
  ) {}

  ngOnInit() {
    this.routes.params.subscribe(
      (success) => {
        this.params = success
        console.log('facet params: ', this.params);
        const keys = Object.keys(this.params)
        this.length = keys.length
        this.cmsService.getCurrentPage().subscribe((resultArray) => {})
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  /**
   * Handles clicking the heading of the facet group, which means toggling
   * the visibility of the group (collapse / expand) and optionally focusing
   * the group.
   */
  toggleGroup(event: UIEvent) {
    const host: HTMLElement = this.elementRef.nativeElement
    const isLocked = this.keyboardFocus?.isLocked

    this.facetService.toggle(this.facet, this.isExpanded)

    if (!isLocked || this.isExpanded) {
      host.focus()
      // we stop propagating the event as otherwise the focus on the host will trigger
      // an unlock event from the LockFocus directive.
      event.stopPropagation()
    }
  }

  get isExpanded(): boolean {
    return this.values.first.nativeElement.offsetParent !== null
  }

  openLink(event: KeyboardEvent) {
    ;(event.target as HTMLElement).click()
    event.preventDefault()
  }

  /**
   * Increases the number of visible values for the facet. This is delegated
   * to `facetService.increaseVisibleValues`.
   */
  increaseVisibleValues(): void {
    this.facetService.increaseVisibleValues(this.facet)
  }

  /**
   * Decreases the number of visible values for the facet. This is delegated
   * to `facetService.decreaseVisibleValues`.
   */
  decreaseVisibleValues(): void {
    this.facetService.decreaseVisibleValues(this.facet);
  }

  getLinkParams(value: FacetValue) {
    return this.facetService.getLinkParams(value.query?.query.value);
  }
  changePage() {
    this.productListComponentService.setPagetoDefault(50);
    if(this.params?.categoryCode)
    this.plpService.setCategoryBreadCrumbs(this.params.categoryCode);
  }
}
